<template>
  <title-container-component title="Tools">
    <v-virtual-scroll :items="listOfActionsGroupBy3" :item-height="1100" height="500" style="height: 100%;
  overflow-y: auto;
  overflow-x: hidden;">
      <template v-slot="{ item }">
        <v-row class="d-flex justify-center">
          <v-col cols="1">
            <JobDialogComponent v-if="
              item[0] !== undefined &&
              !(
                item[0].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[0]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="
              item[1] !== undefined &&
              !(
                item[1].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[1]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[2] !== undefined &&
              !(
                item[2].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[2]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[3] !== undefined &&
              !(
                item[3].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[3]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[4] !== undefined &&
              !(
                item[4].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[4]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[5] !== undefined &&
              !(
                item[5].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[5]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[6] !== undefined &&
              !(
                item[6].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[6]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[7] !== undefined &&
              !(
                item[7].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[7]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[8] !== undefined &&
              !(
                item[8].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[8]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[9] !== undefined &&
              !(
                item[9].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              )
            " :selectedKiosks="selectedKiosks" :item="item[9]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[10] !== undefined &&
              !(
                item[10].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              ) && selectedKiosks.length <= 1
            " :selectedKiosks="selectedKiosks" :item="item[10]" />
          </v-col>
          <v-col cols="1">
            <JobDialogComponent v-if="item[10] !== undefined &&
              !(
                item[11].handleMethod.split('handle')[1] == 'Debug' &&
                selectedKiosks.length > 1
              ) && selectedKiosks.length <= 1
            " :selectedKiosks="selectedKiosks" :item="item[11]" />
          </v-col>
        </v-row>
      </template>
    </v-virtual-scroll>
  </title-container-component>
</template>
<script>
import TitleContainerComponent from "@/components/genericComponents/TitleContainerComponent";
import JobDialogComponent from "@/components/customComponents/JobDialogComponent";
import { store } from "@/models/Store.js";
export default {
  components: { TitleContainerComponent, JobDialogComponent },
  props: {
    selectedKiosks: Array,
  },
  data: () => ({
    store: store,
    actions: [
      {
        icon: "mdi-cellphone-arrow-down",
        handleMethod: "handleAppUpdate",
        dialog: false,
      },
      {
        icon: "mdi-alarm-snooze",
        handleMethod: "handleNoSleep",
        dialog: false,
      },
      {
        icon: "mdi-book-open-variant",
        handleMethod: "handleGetReport",
        dialog: false,
      },
      {
        icon: "mdi-home-analytics",
        handleMethod: "handleGetDiag",
        dialog: false,
      },
      {
        icon: "mdi-table-cog",
        handleMethod: "handleGetSetParam",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-bottle-tonic",
        handleMethod: "handleGetSetProperties",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-cloud-lock-outline",
        handleMethod: "handleWeRepair",
        dialog: false,
      },
      {
        icon: "mdi-cog-counterclockwise ",
        handleMethod: "handleResetName",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-language-java",
        handleMethod: "handleKillJava",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-cloud-braces ",
        handleMethod: "handleDebug",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-archive ",
        handleMethod: "handleArchive",
        dialog: false,
        mustBeAdmin: true
      },
      {
        icon: "mdi-database ",
        handleMethod: "handleBDD Dumps",
        dialog: false,
        mustBeAdmin: true
      },
    ],
  }),
  methods: {},
  computed: {
    listOfActionsGroupBy3() {
      let listToReturn = [];
      let listTmp = [];
      this.actions.forEach((item) => {
        if (this.store.state.isCurrentUserAdmin && item.mustBeAdmin || !item.mustBeAdmin) {
          listTmp.push(item);
        }
        if (((listTmp.length) % 12 === 0) || (this.actions.lastIndexOf(item) === this.actions.length - 1)) {
          if (listTmp.length !== 0) {
            listToReturn.push(listTmp);
            listTmp = [];
          }
        }
      });
      return listToReturn;
    },
  },
};
</script>